import { render, staticRenderFns } from "./series_list.vue?vue&type=template&id=ac36b8d8&scoped=true"
import script from "./series_list.vue?vue&type=script&lang=js"
export * from "./series_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac36b8d8",
  null
  
)

export default component.exports